import { MultiDepositLimitType } from "../deposit-limit/multi/multi-deposit-limit.const";
import { MultiSessionLimitType } from "../session-limit/session-limit.const";

export const validateForm = (
	currentLimits: (number | undefined)[],
	responseLimits: (number | undefined)[],
	validationKey: MultiDepositLimitType | MultiSessionLimitType
) =>
	(responseLimits[0] && currentLimits[0] === responseLimits[0]) ||
	(responseLimits[1] && currentLimits[1] === responseLimits[1]) ||
	(responseLimits[2] && currentLimits[2] === responseLimits[2])
		? { validationKey, forceInvalidForm: true }
		: { validationKey: undefined, forceInvalidForm: false };

export const currentValuesEqualsFormControlValuesValidator = (
	currentLimits: (number | undefined)[],
	responseLimits: (number | undefined)[],
	validationKey: MultiDepositLimitType | MultiSessionLimitType
) => {
	const currentValuesEqualFormControlValues =
		currentLimits[0] === responseLimits[0] &&
		currentLimits[1] === responseLimits[1] &&
		currentLimits[2] === responseLimits[2];

	return currentValuesEqualFormControlValues
		? { validationKey, forceInvalidForm: true }
		: { validationKey: undefined, forceInvalidForm: false };
};
